{
  "salon-card": {
    "text": {
      "and-x-more": "and {{nr}} more",
      "points": "points"
    }
  }
}
